import { useEffect, useState } from 'react';

export function useMatchMedia(query) {
    const [queryMatch, setQueryMatch] = useState(false);
    useEffect(() => {
        if (window && window.matchMedia) {
            let mediaQueryList = window.matchMedia(`(min-width: ${query})`);
            const setQuery = () => setQueryMatch(mediaQueryList.matches);
            setQuery();

            if (mediaQueryList?.addEventListener) {
                mediaQueryList?.addEventListener('change', setQuery);
            } else {
                mediaQueryList?.addListener(setQuery);
            }
            //mediaQueryList.addEventListener('change', setQuery);

            return () => {
                if (mediaQueryList?.removeEventListener) {
                    mediaQueryList?.removeEventListener('change', setQuery);
                } else {
                    mediaQueryList?.removeListener(setQuery);
                }
                //mediaQueryList.removeEventListener('change', setQuery);
            };
        }
    }, [query]);

    return queryMatch;
}
